export enum MathComparance {
    GT = ">",
    GT_EQ = ">=",
    EQ = "=",
    LT = "<",
    LT_EQ = "<="
}
